import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Trainee } from 'app/shared/models/class/trainee/trainee';

export interface DialogData {
  offerKey: string;
}

@Component({
  selector: 'app-open-dialog-go-to-offer-session',
  templateUrl: './open-dialog-go-to-offer-session.component.html',
  styleUrls: ['./open-dialog-go-to-offer-session.component.scss']
})
export class OpenDialogGoToOfferSessionComponent implements OnInit {
  trainee: Trainee[];

  constructor(
    public dialogRef: MatDialogRef<OpenDialogGoToOfferSessionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,

  ) { }

  ngOnInit(): void { }

  closeDialog(): void {
    this.dialogRef.close();
  }



}
